import React from 'react';
import { Toast as BootstrapToast } from 'react-bootstrap';
import Button from '../Button/Button';
import './Toast.css';
import { translate } from '../../translations';

export class Toast extends React.PureComponent {
    handleActionButtonClick = () => {
        this.props.actionButtonClick(this.props.id);
    };

    handleDismissButtonClick = () => {
        this.props.dismissButtonClick(this.props.id);
    };

    handleRetryButtonClick = () => {
        this.props.retryButtonClick();
        this.props.dismissButtonClick(this.props.id);
    };

    renderToast = (type) => {
        switch (type) {
        // TODO: refactor alert to use Bootstrap Toast UPN-9099
            case 'alert': {
                let componentClasses = 'toastWrapper slideIn';
                if (this.props.isHidden) {
                    componentClasses += ' removeToast';
                }
                return (
                    <div id={this.props.id} className={componentClasses}>
                        <div id="toastColorBar" />
                        <div id="toastContent">
                            <div id="toastText">{this.props.displayText}</div>
                            <div id="toastButtonContainer">
                                {this.props.actionButtonClick
                  && (
                      <div
                          id="viewTask"
                          role="button"
                          tabIndex={0}
                          onClick={this.handleActionButtonClick}
                          className="toastButton"
                      >
                          {this.props.actionButtonText}
                      </div>
                  )}
                                <div
                                    id="dismissToast"
                                    role="button"
                                    tabIndex={0}
                                    onClick={this.handleDismissButtonClick}
                                    className="toastButton"
                                >
                                    {this.props.dismissButtonText}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
            case 'error': {
                let componentClasses = 'toastWrapper slideIn toastError';
                if (this.props.isHidden) {
                    componentClasses += ' removeToast';
                }
                return (
                    <div className={componentClasses}>
                        <div id="toastErrorColorBar" />
                        <div id="toastErrorContent">
                            <div>
                                <div id="toastText">{`${this.props.errorMessage || translate('error_message')}`}</div>
                                <div id="toastErrorText">
                                    <strong>
                                        {`${translate('status_code')}:`}
                                    </strong>
                                    <div>{`${this.props.errorCode}`}</div>
                                </div>
                            </div>
                            <div id="toastButtonContainer">
                                <div
                                    id="dismissToast"
                                    role="button"
                                    tabIndex={0}
                                    onClick={this.handleDismissButtonClick}
                                    className="toastButton"
                                >
                                    {translate('dismiss')}
                                </div>
                            </div>
                            {!!this.props.retryButtonClick
                            && (
                                <div
                                    role="button"
                                    tabIndex={0}
                                    onClick={this.handleRetryButtonClick}
                                    className="toastButton retryButton"
                                >
                                    {translate('retry')}
                                </div>
                            )}
                        </div>
                    </div>
                );
            }
            case 'snackbar': {
                const {
                    animation,
                    autoHide,
                    classNames,
                    delay,
                    displayText,
                    onClick,
                    onClose,
                    show,
                } = this.props;

                return (
                    <BootstrapToast
                        animation={animation}
                        autohide={autoHide}
                        className={classNames ? `snackbar ${classNames}` : 'snackbar'}
                        delay={delay}
                        onClick={onClick}
                        onClose={onClose}
                        show={show}
                    >
                        <BootstrapToast.Body>
                            {displayText}
                        </BootstrapToast.Body>
                    </BootstrapToast>
                );
            }
            case 'customNotification': {
                // currently, there are no animations for this type of toast,
                // this is intended to be used in a position relative to the parent component (not absolute/static)
                // in order to add an animation, add it to the parent component (@see: 'LocationOverrideModal.js')

                const {
                    id,
                    isHidden,
                    variant, // accepts: info, danger, warning, success
                    displayText,
                    buttonsConfig,
                } = this.props;

                const componentClasses = [
                    'toastNotificationWrapper',
                    isHidden ? 'removeToast' : '',
                ].filter(Boolean).join(' ');

                return (
                    <div id={id} className={componentClasses}>
                        <div id="toastColorBar" className={`${variant}Toast`} />
                        <div className="toastNotificationText">
                            {displayText}
                        </div>
                        <div className="toastNotificationButtonContainer">
                            {buttonsConfig.map(({ text, onClick }) => (
                                <Button
                                    content={text}
                                    variant="secondary"
                                    onClick={onClick}
                                />
                            ))}
                        </div>
                    </div>
                );
            }
            default:
                return (<> </>);
        }
    };

    render() {
        const {
            type,
        } = this.props;

        return this.renderToast(type);
    }
}

export default Toast;
